import { useBrowser } from "@stepapp/core";
import {
  Block,
  BottomSheet,
  Button,
  SvgIcon,
  Touchable,
  Typography,
  palette,
  spacing,
} from "@stepapp/ui";
import React, { useCallback, useEffect, useState } from "react";
import { FieldError } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { StyleSheet } from "react-native";
import { useAppLinks } from "../../hooks";

type Props = {
  formError?: FieldError;
};

const HouseAreaOutOfScopeSheet = ({ formError }: Props) => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  const { Contact } = useAppLinks();
  const openBrowser = useBrowser(Contact);

  const handleCloseModal = useCallback(() => {
    setVisible(false);
  }, []);

  const handleOpenContactLink = useCallback(() => {
    handleCloseModal();
    openBrowser();
  }, [handleCloseModal, openBrowser]);

  useEffect(() => {
    if (!formError || formError?.type !== "too_big") return;

    setVisible(true);
  }, [formError]);

  return (
    <BottomSheet contentStyle={styles.container} toggle={handleCloseModal} visible={visible}>
      <Block alignStart padding={1}>
        <Touchable onPress={handleCloseModal}>
          <Block alignCenter justifyCenter style={styles.closeIcon}>
            <SvgIcon color={palette.secondary.grey} name="cross" size={36} />
          </Block>
        </Touchable>
      </Block>

      <Block paddingBottom={3} paddingHorizontal={4}>
        <Block alignCenter justifyCenter paddingBottom={6}>
          <SvgIcon name="warning" />

          <Block paddingVertical={4}>
            <Typography center type="white" variant="newH1">
              {t("components.houseAreaOutOfScope.houseAreaIsTooLarge")}
            </Typography>
          </Block>
          <Typography center type="white" variant="body">
            {t("components.houseAreaOutOfScope.orderForLargerHouseArea")}
          </Typography>
        </Block>
        <Button
          label={t("components.houseAreaOutOfScope.writeAndOrderCustomCleaning")}
          onPress={handleOpenContactLink}
          type="secondary"
        />
      </Block>
    </BottomSheet>
  );
};

export default React.memo(HouseAreaOutOfScopeSheet);

const styles = StyleSheet.create({
  closeIcon: {
    backgroundColor: palette.common.black,
    borderRadius: 20,
    borderTopStartRadius: 20,
    marginBottom: spacing.unit * 2.5,
  },
  container: {
    backgroundColor: palette.primary.accent,
    padding: spacing.unit * 2.5,
  },
});
